import React from 'react';
import { sparkToast } from '@spark';
import { TaskType } from '@/shared/domain/taskTypes';
import { useDatasetExport } from '@/features/datasets/hooks/useDatasetExport';
import { DatasetExportControl } from '@/features/datasets/components/DatasetExportControl';

export const ExportButton = ({
    currentUsecase,
    isBenchmark,
    isArchived = false,
    currentFilters,
    extraParamsTitles = [],
    disabled = false,
    role
}) => {
    const {
        runExport,
        exporting,
        exportPercent,
        dropdownOpen,
        setDropdownOpen,
    } = useDatasetExport();
    const isClassification = currentUsecase?.task_type === TaskType.classification;

    const handleExport = (format = 'json') => {
        if (!currentUsecase?._id) {
            sparkToast.error('Cannot export: missing usecase information');
            return;
        }

        const datasetKind = isBenchmark ? 'benchmark' : 'dataset';
        const archivedSuffix = isArchived ? '_archived' : '';
        const filename = `${currentUsecase.usecase_name}_${datasetKind}${archivedSuffix}.${format}`;

        const extraColumns = Array.isArray(extraParamsTitles)
            ? extraParamsTitles.filter(Boolean)
            : [];

        runExport({
            requestData: {
                llm_usecase_id: currentUsecase._id,
                is_benchmark: isBenchmark,
                task_type: currentUsecase.task_type,
                filters:
                    currentFilters && Object.keys(currentFilters).length > 0
                        ? currentFilters
                        : undefined,
                extra_columns: extraColumns.length > 0 ? extraColumns : undefined,
                format,
            },
            filename,
            onError: (error) => {
                sparkToast.error(typeof error === 'string' ? error : 'Export failed');
            },
        });
    };

    return (
        <DatasetExportControl
            onExport={handleExport}
            isClassification={isClassification}
            disabled={disabled || role === 'Viewer'}
            exporting={exporting}
            exportPercent={exportPercent}
            dropdownOpen={dropdownOpen}
            onDropdownOpenChange={setDropdownOpen}
        />
    );
};
